import React from 'react';

import { Modal } from 'src/components/common';
import { SendEmployeeInviteModalContent } from 'src/components/employee/SendEmployeeInviteModalContent';
import type { EmployeeInviteLinkArgs, ResendInviteScope } from 'src/hooks/employee';
import { useModalV2 } from 'src/hooks/shared';
import type { ModalV2Props } from 'src/types/modalV2';

export type SendEmployeeInviteModalProps = {
  employeeId: string;
  employeeSsnEncrypted: string;
  inviteEmailOptionsScope: 'admin' | 'employerScope';
  sendInviteScope: ResendInviteScope;
  inviteLinkArgs?: EmployeeInviteLinkArgs | null;
  onInviteSent?: () => void;
};

export const SendEmployeeInviteModal: React.FC<ModalV2Props<SendEmployeeInviteModalProps>> = ({
  id,
  employeeId,
  employeeSsnEncrypted,
  inviteEmailOptionsScope,
  sendInviteScope,
  inviteLinkArgs,
  onInviteSent,
}) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Invite"
      maxWidth={560}
      headerProps={{ sx: { pb: 0 } }}
      dialogProps={{
        fullWidth: true,
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <SendEmployeeInviteModalContent
        employeeId={employeeId}
        employeeSsnEncrypted={employeeSsnEncrypted}
        inviteEmailOptionsScope={inviteEmailOptionsScope}
        sendInviteScope={sendInviteScope}
        inviteLinkArgs={inviteLinkArgs}
        onInviteSent={onInviteSent}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
